import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSparkpostComponent } from './simple-icons-sparkpost.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSparkpostComponent ],
    exports:      [ SimpleIconsSparkpostComponent ],
    bootstrap:    []
})
export class SimpleIconsSparkpostModule {}
